import { render, staticRenderFns } from "./CabeceraModalEditar.vue?vue&type=template&id=548c48bc&"
import script from "./CabeceraModalEditar.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalEditar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports